import {LoanBorrowPipe} from './pipes/loan-borrow.pipe';
import {SafePipe} from './pipes/safe.pipe';
import {NgxPermissionsModule} from 'ngx-permissions';
import {TorchUnitStatusPipe} from './pipes/torch-unit-status.pipe';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SearchBarComponent} from './components/search-bar/search-bar.component';
import {MatIconModule} from '@angular/material/icon';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {FlexModule} from '@angular/flex-layout';
import {HighlightSearchPipe} from './pipes/highlight-search.pipe';
import {GetByIdPipe} from './pipes/get-by-id.pipe';
import {DirectivesModule} from './directives/directives.module';
import {TitleCasePipe} from './pipes/title-case.pipe';
import {SimpleNumberPipe} from './pipes/simple-number.pipe';
import {BoolToYesNoPipe} from './pipes/bool-to-yes-no.pipe';
import {TorchFlagPipe} from './pipes/torch-flag.pipe';
import {TorchQuantityPipe} from './pipes/torch-quantity.pipe';
import {TorchAbbreviationsPipe} from './pipes/torch-abbreviations.pipe';
import {ClassPipe} from './pipes/class.pipe';
import {FeedbackDialogComponent} from './components/feedback-dialog/feedback-dialog.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatDialogModule} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {FuseSharedModule} from '../../@fuse/shared.module';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from '@angular/material/select';
import {MatTooltipModule} from '@angular/material/tooltip';
import {EditorModule} from '@tinymce/tinymce-angular';
import {SafeHtmlPipe} from './pipes/safe-html.pipe';
import {FileUploadDialogComponent} from './components/file-upload-dialog/file-upload-dialog.component';
import {FileInfoDialogComponent} from './components/file-info-dialog/file-info-dialog.component';
import {MatChipsModule} from '@angular/material/chips';
import {NgxFileDropModule} from 'ngx-file-drop';
import {MatListModule} from '@angular/material/list';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {NotificationColorPipe} from './pipes/notification-color.pipe';
import {NotificationIconPipe} from './pipes/notification-icon.pipe';
import {ManageUserComponent} from './components/manage-user/manage-user.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {PermissionNamePipe} from './pipes/permission-name.pipe';
import {UserFilesListComponent} from './components/user-files-list/user-files-list.component';
import {CdkScrollableModule, ScrollingModule} from '@angular/cdk/scrolling';
import {LogItemFilterPipe} from './pipes/log-item-filter-pipe.pipe';
import {LogItemNonZeroPipe} from './pipes/log-item-non-zero.pipe';
import {LogItemAllDraftPipe} from './pipes/log-item-all-draft.pipe';
import {RecentPartHealthComponent} from './components/recent-part-health/recent-part-health.component';
import {FadeComponent} from './components/fade/fade.component';
import {UnknownPipe} from './pipes/unknown.pipe';
import {ManageUserRolesComponent} from './components/manage-user-roles/manage-user-roles.component';
import {UserInfoComponent} from './components/user-info/user-info.component';
import {AbbreviateNumberPipe} from './pipes/abbreviate-number.pipe';
import {NgxFancyLoggerModule} from 'ngx-fancy-logger';
import {AlertWrapperComponent} from './components/alert-wrapper/alert-wrapper.component';
import {MtxAlertModule} from '@ng-matero/extensions';
import {SpellCheckerModule} from 'ngx-spellchecker';
import {SpellingService} from './services/spelling.service';
import {FilesAuthComponent} from './components/files-auth/files-auth.component';
import {SnakeCaseToTitleCasePipe} from './pipes/snake-case-to-title-case.pipe';
import {RogueCaseRecommendationPipe} from './pipes/rogue-case-recommendation.pipe';
import {RogueCaseActionPipe} from './pipes/rogue-case-action.pipe';
import {MatRippleModule} from '@angular/material/core';
import {ModFleetPipe} from './pipes/mod-fleet.pipe';
import {MasterCpnFlagsPipe} from './pipes/masterCpnFlags.pipe';
import {TorchJobTitlePipe} from './pipes/torch-job-title.pipe';
import {PhaseOfFlightPipe} from './pipes/phase-of-flight.pipe';

@NgModule({
  declarations: [
    SearchBarComponent,
    HighlightSearchPipe,
    GetByIdPipe,
    TitleCasePipe,
    SimpleNumberPipe,
    BoolToYesNoPipe,
    TorchFlagPipe,
    TorchQuantityPipe,
    TorchAbbreviationsPipe,
    ClassPipe,
    TorchUnitStatusPipe,
    FeedbackDialogComponent,
    SafeHtmlPipe,
    FileUploadDialogComponent,
    FileInfoDialogComponent,
    NotificationColorPipe,
    NotificationIconPipe,
    ManageUserComponent,
    PermissionNamePipe,
    UserFilesListComponent,
    LogItemNonZeroPipe,
    LogItemAllDraftPipe,
    LogItemFilterPipe,
    RecentPartHealthComponent,
    FadeComponent,
    SafePipe,
    LoanBorrowPipe,
    UnknownPipe,
    ManageUserRolesComponent,
    UserInfoComponent,
    AbbreviateNumberPipe,
    AlertWrapperComponent,
    FilesAuthComponent,
    SnakeCaseToTitleCasePipe,
    RogueCaseRecommendationPipe,
    RogueCaseActionPipe,
    ModFleetPipe,
    MasterCpnFlagsPipe,
    TorchJobTitlePipe,
    PhaseOfFlightPipe,
  ],
  imports: [
    NgxFancyLoggerModule.forRoot({
      showTime: false,
      showEmoji: false
    }),
    CommonModule,
    MatIconModule,
    ReactiveFormsModule,
    FlexModule,
    FormsModule,
    DirectivesModule,
    MatFormFieldModule,
    MatToolbarModule,
    MatDialogModule,
    MatButtonModule,
    FuseSharedModule,
    MatInputModule,
    MatSelectModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatListModule,
    NgxFileDropModule,
    MatChipsModule,
    EditorModule,
    NgxPermissionsModule,
    MatExpansionModule,
    CdkScrollableModule,
    ScrollingModule,
    MtxAlertModule,
    SpellCheckerModule.forChild(),
    MatRippleModule
  ],
  exports: [
    SearchBarComponent,
    HighlightSearchPipe,
    GetByIdPipe,
    TitleCasePipe,
    SimpleNumberPipe,
    BoolToYesNoPipe,
    TorchFlagPipe,
    TorchQuantityPipe,
    TorchAbbreviationsPipe,
    ClassPipe,
    TorchUnitStatusPipe,
    NgxPermissionsModule,
    SafeHtmlPipe,
    FileUploadDialogComponent,
    FileInfoDialogComponent,
    NotificationColorPipe,
    NotificationIconPipe,
    ManageUserComponent,
    PermissionNamePipe,
    UserFilesListComponent,
    LogItemNonZeroPipe,
    LogItemAllDraftPipe,
    LogItemFilterPipe,
    RecentPartHealthComponent,
    FadeComponent,
    SafePipe,
    LoanBorrowPipe,
    UnknownPipe,
    UserInfoComponent,
    ManageUserRolesComponent,
    AbbreviateNumberPipe,
    AlertWrapperComponent,
    FilesAuthComponent,
    SnakeCaseToTitleCasePipe,
    RogueCaseRecommendationPipe,
    RogueCaseActionPipe,
    ModFleetPipe,
    MasterCpnFlagsPipe,
    TorchJobTitlePipe,
    PhaseOfFlightPipe,
  ],
  providers: [
    SpellingService
  ]
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
    };
  }
}
